<template>
  <div class="compound public-content">
    <div class="breadcrumb">页面名称管理</div>
    <div class="add-category">
      <div class="keywords">
        <span style="margin:0 10px 0 0">页面类型:</span>
        <el-select v-model="searchPageNameVo.pageTypeCode" clearable placeholder="请选择">
          <el-option v-for="item in $store.state.pms.pageTypeList" :key="item.id" :label="item.typeName" :value="item.typeCode"></el-option>
        </el-select>
        <span style="margin:0 10px 0 20px">页面名称:</span>
        <el-input v-model="searchPageNameVo.typeName"></el-input>
      </div>
      <div>
        <el-button round @click="queryInfo.pageNum = 1, getPageNameList()">查询</el-button>
        <el-button round type="primary" v-permission="'pms:admin:page:type:detail'" @click="dialogVisible = true">页面类型管理 </el-button>
        <el-button round type="primary" v-permission="'pms:admin:page:name:add'" @click="dialogVisible2 = true">新建页面名称 </el-button>
      </div>
    </div>
    <div class="right-main">
      <div class="data-list">
        <el-table :data="tableData" border>
          <el-table-column label="页面名称" min-width="100px" prop="typeName"></el-table-column>
          <el-table-column label="页面类型" min-width="100px">
            <template slot-scope="scope"> {{ $store.state.pms.pageType[scope.row.pageTypeCode] }} </template>
          </el-table-column>
          <el-table-column label="是否允许修改P数" min-width="100px">
            <template slot-scope="scope">{{ scope.row.isEditable ? '是' : '否' }}</template>
          </el-table-column>
          <el-table-column label="是否计入基础P数" min-width="100px">
            <template slot-scope="scope">{{ scope.row.isBase ? '是' : '否' }}</template>
          </el-table-column>
          <el-table-column label="匹配模板性质" prop="templateProperty" min-width="100px">
            <template slot-scope="scope">
              <!-- <span class="color-blue" @click="editPageId = scope.row.id, editProperty = true" v-if="$hasPermission('pts:admin:page:tem:edit')">{{ scope.row.templateProperty }}</span>
              <span v-else>{{ scope.row.templateProperty }}</span> -->
              <span>{{ scope.row.templateProperty }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="100px">
            <template v-slot="scope">
              <span class="color-blue" v-permission="'pms:admin:page:type:delete'" @click="deleteId = scope.row.id, deleteDialog = true">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--    分页-->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" v-if="queryInfo.total !== ''" @changePage="changePage"></v-pagination>
    <!-- 页面类型管理 -->
    <el-dialog :close-on-click-modal="false" title="页面类型管理" :visible.sync="dialogVisible" width="30%">
      <el-table :data="$store.state.pms.pageTypeList" border style="width: 100%">
        <el-table-column prop="typeName" label="页面类型"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 新建页面名称 -->
    <el-dialog :close-on-click-modal="false" title="新建页面名称" :visible.sync="dialogVisible2" @closed="closed" width="30%">
      <el-form ref="addPageNameForm" hide-required-asterisk :model="newPageMsg" :rules="addPageNameRules" label-width="140px">
        <el-form-item label="页面类型" prop="pageTypeCode">
          <el-select v-model="newPageMsg.pageTypeCode" placeholder="请选择">
            <el-option v-for="item in $store.state.pms.pageTypeList" :key="item.id" :label="item.typeName" :value="item.typeCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="页面名称" prop="typeName">
          <el-input v-model="newPageMsg.typeName" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="是否算入基础P数：">
          <el-switch v-model="newPageMsg.isBase" active-color="rgba(20, 115, 230, 1)" inactive-color="rgba(140, 140, 140, 1)"></el-switch>
          <el-tooltip class="item" effect="dark" content="启用后，此页面计入基础p数" placement="right-end">
            <i class="el-icon-question" style="margin-left:2px;font-size:20px;vertical-align: middle;"></i>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="是否允许修改数量：">
          <el-switch v-model="newPageMsg.isEditable" active-color="rgba(20, 115, 230, 1)" inactive-color="rgba(140, 140, 140, 1)"></el-switch>
          <el-tooltip class="item" effect="dark" content="启用后，此页面可以修改数量" placement="right-end">
            <i class="el-icon-question" style="margin-left:2px;font-size:20px;vertical-align: middle;"></i>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="匹配模板性质：" prop="selectedPropertyList">
          <el-select value-key="id" v-model="selectedProperty" placeholder="请选择">
            <el-option v-for="item in propertyList" :key="item.id + item.propertyName" :label="item.propertyName" :value="item"></el-option>
          </el-select>
          <el-button type="primary" @click="addProperty" round style="margin:0 0 10px 10px">添加</el-button>
          <el-table :data="selectedPropertyList" border style="width: 100%">
            <el-table-column prop="propertyName" label="性质" width="180"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <span class="color-blue" @click="selectedPropertyList.splice(scope.$index, 1)">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addPage">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 删除确认 -->
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="deleteDialog" width="30%">
      <span>确认删除该页面名称？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deletePageName(deleteId)">确 定</el-button>
      </span>
    </el-dialog>
    <!-- edit -->
    <el-dialog :close-on-click-modal="false" title="重选模板性质" :visible.sync="editProperty" width="30%" @closed="closed">
      <el-select value-key="id" v-model="selectedProperty" placeholder="请选择">
        <el-option v-for="item in propertyList" :key="item.id + item.propertyName" :label="item.propertyName + ',' + item.propertyCode" :value="item"></el-option>
      </el-select>
      <el-button type="primary" @click="addProperty" round style="margin:0 0 10px 10px">添加</el-button>
      <el-table :data="selectedPropertyList" border style="width: 100%">
        <el-table-column prop="propertyName" label="性质" width="180"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span class="color-blue" @click="selectedPropertyList.splice(scope.$index, 1)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editProperty = false">取 消</el-button>
        <el-button type="primary" @click="edit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import VPagination from '@/components/Pagination/index'
import { sizeListPaging, pageNameAdd, pageNameDelete, updateTemplateProperty, propertyGetPropertyList, pageNameListPage, pageTypeList, composeTypeDetail, bleedDetail } from '@/api/pms'
export default {
  name: 'compound',
  components: {
    VPagination
  },
  data () {
    var checkProPerty = (rule, value, callback) => {
      if (this.selectedPropertyList.length === 0) {
        callback(new Error('请选择匹配模板性质'))
      } else {
        callback()
      }
    }
    return {
      editPageId: '',
      editProperty: false,
      deleteId: '',
      deleteDialog: false,
      selectedProperty: '',
      selectedPropertyCode: '',
      selectedPropertyList: [],
      searchPageNameVo: {
        pageTypeCode: '',
        typeName: ''
      },
      pageTypeTableData: [],
      value: false,
      form: [],
      newPageMsg: {
        isBase: false,
        isEditable: false,
        pageTypeCode: '',
        templateProperty: [],
        typeName: '',
        templatePropertyCode: []
      },
      dialogVisible: false,
      dialogVisible2: false,
      formInline: [],
      composeList: [],
      keywords: '',
      queryInfo: {
        type: 3,
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      },
      compoundType: [],
      tableData: [],
      propertyList: [],
      addPageNameRules: {
        pageTypeCode: [
          { required: true, message: '请选择页面类型', trigger: 'change' }
        ],
        typeName: [
          { required: true, message: '请输入页面名称', trigger: 'blur' }
        ],
        selectedPropertyList: [
          { validator: checkProPerty, trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    this.getPageNameList()
    this.getPropertyList()
    this.$store.dispatch('pms/getPageTypeList')
  },
  methods: {
    edit () {
      if (this.selectedPropertyList.length === 0) {
        this.$message.error('未选择模板性质')
        return
      }
      let templateProperty = []
      let templatePropertyCode = []
      this.selectedPropertyList.forEach(item => {
        templateProperty.push(item.propertyName)
        templatePropertyCode.push(item.propertyCode)
      })

      templateProperty = templateProperty.join(',')
      templatePropertyCode = templatePropertyCode.join(',')
      updateTemplateProperty({ pageId: this.editPageId, params: { templateProperty } }).then(res => {
        if (res.data.success) {
          this.getPageNameList()
          this.$message.success('修改成功')
          this.editProperty = false
        }
      })
    },
    closed () {
      this.newPageMsg = {
        isBase: false,
        isEditable: false,
        pageTypeCode: '',
        templateProperty: [],
        typeName: '',
        templatePropertyCode: []
      }
      this.selectedProperty = ''
      this.selectedPropertyList = []
      this.$nextTick(_ => {
        this.$refs.addPageNameForm.clearValidate()
      })
    },
    // 添加模板性质
    addProperty () {
      if (this.selectedProperty === '') {
        this.$message.error('请选择匹配模板性质')
        return
      }
      let lock = true
      this.selectedPropertyList.forEach(item => {
        if (item.id === this.selectedProperty.id) {
          lock = false
        }
      })
      if (lock) {
        this.selectedPropertyList.push(this.selectedProperty)
        this.$refs.addPageNameForm.validateField('selectedPropertyList')
      }
    },
    // 获取模板性质
    getPropertyList () {
      propertyGetPropertyList().then(res => {
        if (res.data.success) {
          this.propertyList = res.data.data
        }
      })
    },
    // 删除页面名称
    deletePageName (id) {
      pageNameDelete(id).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.getPageNameList()
          this.deleteDialog = false
        }
      })
    },
    // 获取页面名称列表
    getPageNameList () {
      pageNameListPage({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, searchPageNameVo: this.searchPageNameVo }).then(res => {
        if (res.data.success) {
          this.queryInfo.total = res.data.data.total
          this.tableData = res.data.data.records
        }
      })
    },
    // 添加页面
    addPage () {
      this.$refs.addPageNameForm.validate((valid) => {
        if (!valid) {
          return
        }
        let propertyNameList = []
        let propertyCodeList = []
        this.selectedPropertyList.forEach(item => {
          propertyNameList.push(item.propertyName)
          propertyCodeList.push(item.propertyCode)
        })
        this.newPageMsg.templateProperty = propertyNameList.join(',')
        this.newPageMsg.templatePropertyCode = propertyCodeList.join(',')
        pageNameAdd(this.newPageMsg).then(res => {
          if (res.data.success) {
            this.$message.success('新建成功')
            this.getPageNameList()
            this.dialogVisible2 = false
          }
        })
      })
    },
    // 获取页面类型列表
    // getPageNameType () {
    //   pageTypeList().then(res => {
    //     if (res.data.success) {
    //       this.$store.state.pms.pageTypeList = res.data.data
    //     }
    //   })
    // },
    // ------------------------------------
    changePage (val) {
      this.queryInfo = val
      this.getPageNameList()
    }
  }
}
</script>

<style scoped lang="less">
.compound {
  .add-category {
    justify-content: space-between;
  }

  .keywords {
    .el-input {
      width: 180px;
    }
  }
}
</style>
